import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import LogoImage from './LogoImage';

/**
 * Displays the compact legacy RPL Robot branding used by dashboard headers
 *
 * @returns {JSX.Element}
 */
const DashboardLogo = () => {
    const theme = useTheme();
    const textSx = {
        textDecoration: 'none',
        fontFamily: 'URW DIN BOLD',
        color: theme.palette.primary.main
    };

    return (
        <Grid container>
            <Grid item sm={12} display="flex" alignItems="center" gap={1}>
                <LogoImage width="40%" />
                <Grid container display="block">
                    <Grid item>
                        <Typography variant="h6" className="main-font-b" sx={textSx}>
                            TLRG
                        </Typography>
                    </Grid>
                    <Grid item sx={{ mt: '-5px' }}>
                        <Typography variant="h3" className="main-font-b" sx={textSx}>
                            RPL
                        </Typography>
                    </Grid>
                    <Grid item sx={{ mt: '-3px' }}>
                        <Typography variant="h2" className="main-font-b" sx={textSx}>
                            ROBOT
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default DashboardLogo;
